import { registerReducer } from 'foremanReact/common/MountingService';
import rootReducer from '../redux/reducers';

export default () =>
  registerReducer('foremanRemoteExecutionReducers', rootReducer);



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/react_app/extend/reducers.js